import React from "react";
import "./MentorGallery.css";

// const mentors = [
//
//
//
//
//
//
//
//     
//     
// ];

const mentors = [
    {
        image: "/images/Iris.png",
        linkedin: "https://www.linkedin.com/in/icheung/",
    },
    {
        image: "/images/Leo.png",
        linkedin: "https://www.linkedin.com/in/leonidas-zhang/",
    },
    {
        image: "/images/Justin.png",
        linkedin: "https://www.linkedin.com/in/justin-galimpin/",
    },
    {
        image: "/images/Israel.png",
        linkedin: "https://www.linkedin.com/in/israeleniola/",
    },
    {
        image: "/images/Johnson.png",
        linkedin: "https://www.linkedin.com/in/johnson-luong/",
    },
    {
        image: "/images/Sam.png",
        linkedin: "https://www.linkedin.com/in/saml1009/",
    },
    {
        image: "/images/Terry.png",
        linkedin: "https://www.linkedin.com/in/terrychou28/",
    },
    {
        image: "/images/Brett.png",
        linkedin: "https://www.linkedin.com/in/brett-farewell/",
    },
    {
        image: "/images/Kieran.png",
        linkedin: "https://www.linkedin.com/in/kieran-stewart1/",
    },
    {
        image: "/images/Jeffery.png",
        linkedin: "https://www.linkedin.com/in/jeffreyho1211/",
    },
    {
        image: "/images/Charlie.png",
        linkedin: "https://www.linkedin.com/in/charlieshuchen/",
    },
];

const MentorGallery: React.FC = () => {
    return (
        <div className="mentor-gallery">
            <h3 className="mentor-heading">Meet the Team</h3>
            <div className="mentor-grid">
                {mentors.map((mentor, index) => (
                    <a
                        key={index}
                        href={mentor.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mentor-link"
                    >
                        <div className="mentor-card">
                            <img
                                src={mentor.image}
                                alt={`Mentor ${index + 1}`}
                                className="mentor-photo"
                            />
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default MentorGallery;
